import { action, makeObservable, observable } from 'mobx';
import { string } from 'prop-types';

export interface ISuppressionRule {
    id?: string;
    suppressionRuleId?: string;
    alertId?: string;
    name: string;
    description: string;
    metadata?: any;
    author?: any;
    createdOn?: string;
    active?: boolean;
    organizationId?: string;
    organization?: any;
    locationId?: string;
    location?: any;
}

export default class SuppressionRuleStore {
    suppressionRule: ISuppressionRule = {
        name: '',
        description: '',
        author: {},
        organization: {},
        location: {}
    };

    constructor(suppressionRule: ISuppressionRule & { author?: { email: string } }) {
        this.update(suppressionRule);

        makeObservable(this, {
            suppressionRule: observable,
            update: action
        });
    }

    update(suppressionRule: ISuppressionRule & { author?: { email: string } }): void {
        this.suppressionRule = {
            ...this.suppressionRule,
            ...suppressionRule,
            author:
                typeof suppressionRule.author === 'string' ? suppressionRule.author : suppressionRule.author?.email ? suppressionRule.author.email : 'Infocyte'
        };
    }
}
